import React, { useContext } from "react";
import themeContext from "../../../../context/theme/ThemeContext";

const PeerReviewAssignmentIcon = () => {
  const { getThemeColor } = useContext(themeContext);
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      fill="none"
      stroke={getThemeColor("icon-color")}
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    >
      <circle cx="5" cy="9" r="2.25" />
      <circle cx="11" cy="4" r="2.25" />
      <path d="m7.75 9.25c0-1 .75-3 3.25-3s3.25 2 3.25 3m-12.5 5c0-1 .75-3 3.25-3s3.25 2 3.25 3" />
    </svg>
  );
};

export default PeerReviewAssignmentIcon;
